import UIAlert from 'UIComponents/alert/UIAlert';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { connect } from 'react-redux';
import { getIsBlockedLoginMethodAlertVisible } from '../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
const BlockedLoginMethodAlert = ({
  isBlockedLoginMethodAlertVisible
}) => {
  if (!isBlockedLoginMethodAlertVisible) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const i18nKey = 'login.errors.BLOCKED_LOGIN_METHOD';
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: I18n.text(`${i18nKey}.title`),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${i18nKey}.body`
    })
  });
};
const mapStateToProps = state => ({
  isBlockedLoginMethodAlertVisible: getIsBlockedLoginMethodAlertVisible(state)
});
export default connect(mapStateToProps)(BlockedLoginMethodAlert);